import * as React from "react";
import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  Box,
  useDisclosure
} from "@chakra-ui/react";
import {
  IoTrashBinOutline,
  IoFitnessOutline,
  IoAlertCircleOutline,
  IoHeartOutline
} from "react-icons/io5";
import { MdHideSource } from "react-icons/md";
import { Fragments, ToothStateEnum } from "requests";
import { QuickChart, UpdateState } from "./components";

interface ActionsProps {
  selection: NonNullable<Fragments.StoredDentalChartings>;
  flexDirection?: "row" | "row-reverse";
  onDeselectAll(): void;
}

const Actions: React.FC<ActionsProps> = ({
  selection,
  onDeselectAll,
  flexDirection = "row"
}) => {
  const [opened, setOpened] = React.useState(false);
  const {
    isOpen: isQuickChartOpen,
    onOpen: onQuickChartOpen,
    onClose: onQuickChartClose
  } = useDisclosure();

  const btnSize = { base: "sm", xl: "md" };

  const onSuccess = () => {
    setOpened(false);
    onDeselectAll();
  };

  const handleQuickChartClose = () => {
    onQuickChartClose();
    onDeselectAll();
  };

  return (
    <Flex gridGap="16px" flexDirection={flexDirection}>
      <Button
        variant="outline"
        colorScheme="gray"
        isDisabled={selection.length === 0}
        onClick={onQuickChartOpen}
        size={{ base: "sm", xl: "md" }}
      >
        QuickChart
      </Button>
      {isQuickChartOpen && (
        <QuickChart selection={selection} onClose={handleQuickChartClose} />
      )}

      <Menu
        isOpen={opened}
        closeOnSelect={false}
        onOpen={() => setOpened(true)}
        onClose={() => setOpened(false)}
      >
        <MenuButton
          as={Button}
          isDisabled={selection.length === 0}
          size={btnSize}
        >
          Actions
        </MenuButton>
        <MenuList zIndex={4}>
          <UpdateState
            state={ToothStateEnum.Extracted}
            label="Extracted"
            icon={<IoTrashBinOutline />}
            selection={selection}
            onSuccess={onSuccess}
          />

          <UpdateState
            state={ToothStateEnum.Missing}
            label="Missing"
            icon={
              <Box
                w="12px"
                h="12px"
                borderRadius="50%"
                border="1px solid black"
              />
            }
            selection={selection}
            onSuccess={onSuccess}
          />

          <UpdateState
            state={ToothStateEnum.Abnormal}
            label="Abnormal"
            icon={<IoAlertCircleOutline />}
            selection={selection}
            onSuccess={onSuccess}
          />

          <UpdateState
            state={ToothStateEnum.Untreated}
            label="Untreated"
            icon={<IoFitnessOutline />}
            selection={selection}
            onSuccess={onSuccess}
          />

          <UpdateState
            state={ToothStateEnum.Treated}
            label="Treated"
            icon={<IoHeartOutline />}
            selection={selection}
            onSuccess={onSuccess}
          />

          <UpdateState
            state={ToothStateEnum.Unerupted}
            label="Unerupted"
            icon={<MdHideSource />}
            selection={selection}
            onSuccess={onSuccess}
          />
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default Actions;
